import React from 'react'

import { TranslationContext, TranslationContextProps } from '../i18n'

export const useTranslationContext = (): TranslationContextProps => React.useContext(TranslationContext)
